import React, { useState } from 'react';
import { Facebook, Instagram, Youtube, Calendar, Menu, X } from 'lucide-react';

export const Header = ({ onApplyClick }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { href: '#about', label: 'About', isScroll: true },
    { href: '/hair-extensions-franchise-opportunity', label: 'Opportunity' },
    { href: '/sponsorship-opportunity', label: 'Sponsorship' },
    { href: '/resources', label: 'Resources' },
    { href: '/press', label: 'Blog' },
    { href: '/training-academy', label: 'Training Academy' },
  ];

  const handleNavClick = (e, link) => {
    if (link.isScroll) {
      e.preventDefault();
      if (window.location.pathname !== '/') {
        window.location.href = '/#about';
      } else {
        document.getElementById('about')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg border-b-2 border-accent-primary">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_hair-opportunity/artifacts/ro1cz7gd_GIF_20250914_153723_283.gif"
            alt="Need A Hair Makeover - Specialist Salon Franchise"
            className="header-logo"
          />
        </div>
        
        {/* Navigation and Social Links - Desktop */}
        <div className="hidden lg:flex items-center space-x-6">
          {/* Navigation */}
          <nav className="flex items-center space-x-6">
            {navLinks.map((link) => (
              <a 
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link)}
                className="text-dark hover:text-accent-primary transition-colors duration-200 font-medium cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Social Media Icons */}
          <div className="flex items-center space-x-3 border-l border-gray-300 pl-6">
            <a
              href="https://facebook.com/needahairmakeover2"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-blue-600 transition-colors duration-200"
              aria-label="Follow us on Facebook"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href="https://instagram.com/needahairmakeover"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-pink-500 transition-colors duration-200"
              aria-label="Follow us on Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              href="https://www.youtube.com/@needahairmakeover"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-red-600 transition-colors duration-200"
              aria-label="Follow us on YouTube"
            >
              <Youtube className="w-5 h-5" />
            </a>
            <a
              href="https://www.needahairmakeover.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-accent-primary transition-colors duration-200"
              aria-label="Book appointment"
            >
              <Calendar className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Mobile Menu Button + CTA */}
        <div className="flex items-center gap-3">
          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-dark hover:text-accent-primary transition-colors"
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
          
          {/* CTA Button */}
          <a
            href="/apply"
            data-testid="header-apply-btn"
            className="bg-white border-2 border-accent-primary text-accent-primary hover:bg-accent-primary hover:text-white px-4 md:px-6 py-2 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-xl text-sm md:text-base"
          >
            Apply Now
          </a>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg" data-testid="mobile-menu">
          <nav className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              <a 
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link)}
                className="block text-dark hover:text-accent-primary transition-colors duration-200 font-medium py-2 border-b border-gray-100 last:border-0"
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </a>
            ))}
          </nav>
          
          {/* Mobile Social Links */}
          <div className="bg-gray-50 px-6 py-4 border-t">
            <div className="flex items-center justify-center space-x-6">
              <a href="https://facebook.com/needahairmakeover2" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://instagram.com/needahairmakeover" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-pink-500">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/@needahairmakeover" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-red-600">
                <Youtube className="w-5 h-5" />
              </a>
              <a href="https://www.needahairmakeover.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-accent-primary">
                <Calendar className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};